import { FormGroup, Validators, FormControl } from '@angular/forms';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { GetCloudPublicAreaGQL, GetCloudRequestTypeGQL, UpdateServiceRequestGQL } from '../../../../../generated/cloudapigql';
import { FocusMonitor } from '@angular/cdk/a11y';
import { HeaderTemplateData } from '../../dialog/dialog-data.interface';

export interface RequestDetail {
  ID: string;
  lUnitId: number;
  unitNo: string;
  areaDescription: string;
  requestTitle: string;
  requestType: string;
}

export interface Unit {
  unitId: number;
  unitNo: string;
}

export interface DialogData {
  requestDetail: RequestDetail,
  areaTypes: string[],
  units: Unit[],
  requestTypes: string[],
  publicArea: string[],
  header: any
}


@Component({
  selector: 'app-edit-service-request-dialog',
  templateUrl: './edit-service-request-dialog.html',
})
export class EditServiceRequestDialog implements OnInit, AfterViewInit {
  result: DialogData;
  form: FormGroup;
  header:HeaderTemplateData;
  publicAreaOptions:any;
  requestTypeOptions:any;

  constructor(
    public dialogRef: MatDialogRef<EditServiceRequestDialog>,
    private _focusMonitor: FocusMonitor,
    private _getRequestType: GetCloudRequestTypeGQL,
    private _getPublicArea: GetCloudPublicAreaGQL,

    // private
    @Inject(MAT_DIALOG_DATA) private _data: DialogData,
    private updateServiceRequestGQL: UpdateServiceRequestGQL,
    private _snackBar: MatSnackBar,
    private _authService: AuthenticationService
  ) {
    if (_data != null) {
      this.header = _data.header;
      this.result = _data;
    }
    this.getSelectOptions();

  }

  getSelectOptions(){
    this._getPublicArea.fetch().subscribe(result=>{
      this.publicAreaOptions = result.data.getCloudPublicArea
    })
    this._getRequestType.fetch().subscribe(result=>{
      this.requestTypeOptions = result.data.getCloudRequestType
    })
  }


  ngAfterViewInit() {
    for(let i=0; i< 2; i++){
      let radioBtn = document.getElementById('dynamicId'+i);
      this._focusMonitor.stopMonitoring(radioBtn);
    }
  }

  ngOnInit() {
    let previousUnit: Unit = this.result.units?.find(x => x.unitId == this.result.requestDetail.lUnitId) 
    //if cannot find the unit in active rental contract
    //1) don have active rental contract
    //2) active rental contract change to other units
    if(!previousUnit && (this.result.units == undefined || this.result.units?.length == 0) && this.result.requestDetail.lUnitId ){
      this.result.units = [{ unitId:this.result.requestDetail.lUnitId, unitNo:this.result.requestDetail.unitNo } as Unit] as Unit[];
      previousUnit = this.result.units[0]
    } 

    this.form = new FormGroup({
      areaType: new FormControl(),
      requestType: new FormControl(this.result.requestDetail.requestType),
      title: new FormControl(this.result.requestDetail.requestTitle),
    });
    if (this.result.requestDetail.lUnitId) {

      this.form.addControl("unit", new FormControl(previousUnit, [Validators.required]));
      this.form.get('areaType').setValue(this.result.areaTypes.find(x => x == "Unit"));
    } else if (this.result.requestDetail.areaDescription) {
      this.form.addControl("publicArea", new FormControl(this.result.requestDetail.areaDescription, [Validators.required]));
      this.form.get('areaType').setValue(this.result.areaTypes.find(x => x == "Public Area"));
    }

    this.form.get('areaType').valueChanges.subscribe(value => {

      if (value == "Unit") {
        this.form.removeControl("publicArea");
        this.form.addControl("unit", new FormControl(previousUnit ?? null, [Validators.required]));
        // this.form.addControl("unit", new FormControl(previousUnit ?? this.result?.units[0] ?? null, [Validators.required]));
      }
      else {
        this.form.removeControl("unit");
        this.form.addControl("publicArea", new FormControl(this.result.requestDetail.areaDescription ?? this.result.publicArea[0], [Validators.required, Validators.maxLength(250)]));
      }
    });
  }

  onSubmit(item: any) {
    if(this.form.valid){
      let updateModel = this.form.value;
      // console.log("updateModel : ",updateModel);
      this.updateServiceRequestGQL.mutate({
        UpdateServiceRequestModel: {
          propertyId: this._authService.userInfo.property?.propertyId,
          unitNo: updateModel.unit?.unitNo,
          requestId: this.result.requestDetail.ID,
          publicAreaDesc: updateModel.publicArea,
          requestType: updateModel.requestType,
          title: updateModel.title,
          unitId: updateModel.unit?.unitId
        }
      }).subscribe(x => {
        if (x.data.updateServiceRequest == false) {
          // this.dialogRef.close(false);
          // this._snackBar.open('Error: ' + x.data.ApproveOrReject.message, 'Dismiss', { duration: 5000 });
        } else {
          this.dialogRef.close(true);
        }
      });
    }
  }
}
